module.exports = __webpack_public_path__ + "static/img/hefeiwei1.f88d1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hefeiwei1.png
// module id = FIDO
// module chunks = 1